import * as React from 'react';



export default class Add extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <polygon className="st0" points="15,7.5 8.5,7.5 8.5,1 7.5,1 7.5,7.5 1,7.5 1,8.5 7.5,8.5 7.5,15 8.5,15 8.5,8.5 15,8.5 "/>
      </svg>
    )
  }
}
